import { TalentService } from "../talent.service";
import {
  Optional,
  Inject,
  Input,
  Component,
  OnInit,
  ViewEncapsulation,
  SimpleChange,
  NgZone,
} from "@angular/core";
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { RoleDetailEditComponent } from "../role-detail-edit/role-detail-edit.component";
import { formatDate } from "@angular/common";
import { Router, ActivatedRoute } from "@angular/router";
import * as XLSX from "xlsx";
import { PipelineOption } from '../classes/RolePipeline';

@Component({
    selector: "app-open-roles",
    templateUrl: "./open-roles.component.html",
    styleUrls: ["./open-roles.component.css"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class OpenRolesComponent implements OnInit {
  @Input() client_roles: any;
  @Input() filter: string;
  @Input("start_date") start_date: number;
  @Input("end_date") end_date: number;
  contexData: any;
  sortType: string = "open_date";
  sortReverse: boolean = false;
  open_only = true;
  prospective_only = false;
  show_checkbox = true;
  comprehensiveSearch: string = "";
  isComprehensiveSearchActive: boolean = false;
  user_drop_down_data = [];
  role_owner;
  changeOwner = false;
  changeOwnerSave = false;
  showChangeRoleOwner = 0;
  showAddCandidateToRoleBtn = 0;
  isEditable = true;
  showEdit = true;
  showSave = false;
  showEditRecruiter = true;
  showSaveRecruiter = false;
  showEditSourcer = true;
  showSaveSourcer = false;
  showEditPriority = true;
  showSavePriority = false;
  showEditPipeline = true;
  showSavePipeline = false;
  showEditManager = true;
  showSaveManager = false;
  showEditWorkPermission = true;
  showSaveWorkPermission = false;
  showEditPracticeGroup = true;
  showSavePracticeGroup = false;
  workPermissionOptions: any;
  priority_options: any = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  saveChangesDict: any = [];
  saveChangesDictSourcer: any = {};
  saveChangesDictPriority: any = [];
  saveChangesDictPipleine: any = [];
  saveChangesDictRecruiter: any = {};
  saveChangesDictManager: any = [];
  saveChangesWorkPermission: any = {};
  saveChangesDictPracticeGroup: any = [];
  show_detail: Object = {};
  showingSimilarRoles: any = false;
  role_id;
  sourcer_options: any = [];
  user_name_by_id: Object = {};
  work_permission_name_by_id: Object = {};
  roles: any = [];
  allRoles: any = [];
  count: Object = {};
  clients: Array<any> = [];
  clients_lookup: Object = {};
  base_url: String = "";
  fileName = "Open_Roles_Table.xlsx";
  pagination_id = -1;
  practice_group_options: any = [];
  pipelineOptions: PipelineOption[] = [];
  modelOptions: string[] = [];
  p: number = 1;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    @Optional() private dialogRef: MatDialogRef<OpenRolesComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) data,
    private talentService: TalentService,
    private ngZone: NgZone
  ) {
    if (data == null) {
      this.contexData = {
        openRolesContext: "openRoles",
        openRolesContextId: 0,
      };
    } else {
      this.contexData = data;
      this.show_checkbox = false;
    }
  }

  ngOnInit() {
    console.log('Open Roles Component');
    console.log('isInAngularZone:', NgZone.isInAngularZone()); 
    console.log('ngZone exists:', !!this.ngZone); 
    console.log('Zone type:', (Zone as any).current.name);
    this.ngZone.run(() => {
      console.log('inside ngZone.run - isInAngularZone:', NgZone.isInAngularZone());
      if (this.client_roles && this.client_roles.length > 0) {
        this.pagination_id = this.client_roles[0].role_id;
      }
      this.base_url = location.origin;

      this.talentService.getYodaweUsersData().subscribe((yodawe_users) => {
        this.ngZone.run(() => {
          this.user_drop_down_data = yodawe_users;
          let user_info = this.user_drop_down_data.find(
            (x) => x.id === this.talentService.userId
          );
          if (user_info && user_info.edit_role_ownership_access) {
            this.showChangeRoleOwner = 1;
          }
        });
      });

      this.talentService.getRolePracticeGroups().subscribe((result) => {
        this.ngZone.run(() => {
          this.practice_group_options = result;
        });
      });

      this.talentService.getYodaweUsers().subscribe((result) => {
        this.ngZone.run(() => {
          this.sourcer_options = result;
          for (let r of result) {
            this.user_name_by_id[r["id"]] = r["name"];
          }
        });
      });

      this.talentService.getDisplayYesNo().subscribe((result) => {
        this.ngZone.run(() => {
          this.workPermissionOptions = result;
          for (let wp_info of this.workPermissionOptions) {
            this.work_permission_name_by_id[wp_info["id"]] = wp_info["name"];
          }
        });
      });

      this.talentService.getYodaweClients().subscribe((yodawe_client) => {
        this.ngZone.run(() => {
          this.clients = yodawe_client;
          for (let c of this.clients) {
            this.clients_lookup[c["company_name"]] = c["id"];
          }
        });
      });

      this.talentService.getPipelineColours().subscribe((result) => {
        this.ngZone.run(() => {
          this.pipelineOptions = result as PipelineOption[];
          console.log('pipeline options open', this.pipelineOptions);
        });
      });

      this.role_id = this.activatedRoute.snapshot.paramMap.get("id");
      if (
        !this.router.url.includes("client") &&
        !this.router.url.includes("contact") &&
        this.role_id
      ) {
        this.open_only = false;
        this.filter = this.role_id.toString();
      }

      if (this.contexData.openRolesContext == "addToRole") {
        this.showAddCandidateToRoleBtn = 1;
        this.showEdit = false;
        this.talentService
          .getCandidateWorkflow(this.contexData.openRolesContextId)
          .subscribe((result) => {
            this.ngZone.run(() => {
              result.forEach((n) => (this.isDisabled[n.role_id] = true));
            });
          });
      }

      if (this.client_roles) {
        console.log('client_roles', this.client_roles);
        this.filter = "";
        this.open_only = true;
        this.allRoles = this.client_roles;
        if (this.open_only) {
          this.roles = this.client_roles.filter(function (role) {
            return role.status == 1 || role.status == 3;
          });
        } else {
          this.roles = this.client_roles;
        }
      } else {
        if (this.role_id) {
          this.getOpenRoles("all");
          this.show_detail[this.role_id] = true;
        } else {
          this.getOpenRoles("open");
        }
      }
    });
  }

  ngOnchanges(changes: SimpleChange) {
    if (this.open_only) {
      this.allRoles = this.client_roles;
      this.roles = this.client_roles.filter(function (role) {
        return role.status == 1 || role.status == 3;
      });
    } else {
      this.allRoles = this.client_roles;
      this.roles = this.client_roles;
    }
  }

  findRecruiter(role) {
    let found = this.sourcer_options.find((option) => option.id === role.recruiter_id);
    return found ? found.name : "";
  }

  findSourcer(role) {
    let found = this.sourcer_options.find((option) => option.id === role.sourcer_id);
    return found ? found.name : "";
  }

  findManager(role) {
    let found = this.sourcer_options.find((option) => option.id === role.account_manager);
    return found ? found.name : "";
  }

  getOpenRoles(open_or_all): void {
    this.talentService.getOpenRolesNew(open_or_all).subscribe((roles) => {
      this.ngZone.run(() => {
        this.allRoles = roles;
        this.isComprehensiveSearchActive = false;
        this.applyFilters();
      });
    });
  }

  performComprehensiveSearch(): void {
    if (!this.comprehensiveSearch || this.comprehensiveSearch.trim() === "") {
      this.isComprehensiveSearchActive = false;
      if (this.open_only) {
        this.getOpenRoles("open");
      } else {
        this.getOpenRoles("all");
      }
      return;
    }

    const open_or_all = this.open_only ? "open" : "all";
    this.isComprehensiveSearchActive = true;
    this.talentService
      .searchOpenRoles(open_or_all, this.comprehensiveSearch)
      .subscribe((roles) => {
        this.ngZone.run(() => {
          this.allRoles = roles;
          this.roles = roles;
          this.filter = "";
        });
      });
  }

  clearComprehensiveSearch(): void {
    this.comprehensiveSearch = "";
    this.isComprehensiveSearchActive = false;
    if (this.open_only) {
      this.getOpenRoles("open");
    } else {
      this.getOpenRoles("all");
    }
  }

  isDisabled = [];

  Checkbox() {
    this.prospective_only = false;
    if (this.client_roles) {
      this.filter = "";
      this.allRoles = this.client_roles;
      this.applyFilters();
    } else {
      if (this.open_only) {
        this.getOpenRoles("open");
      } else {
        this.getOpenRoles("all");
      }
    }
  }

  ProspectiveCheckbox() {
    this.applyFilters();
  }

  applyFilters() {
    const baseRoles = this.allRoles || this.client_roles || [];
    let filtered = baseRoles;
    if (this.open_only) {
      filtered = filtered.filter((role) => role.status == 1 || role.status == 3);
    }
    if (this.prospective_only) {
      filtered = filtered.filter((role) => role.prospective == 1);
    } else {
      filtered = filtered.filter((role) => !role.prospective);
    }
    this.roles = filtered;
  }

  rowClick(role_id): void {
    var role_detail;
    this.isDisabled[role_id] = true;
    for (var i = 0; i < this.roles.length; i++) {
      if (role_id == this.roles[i].role_id) {
        role_detail = this.roles[i];
      }
    }
    console.log("role_id clicked: " + role_id);

    if (this.contexData.openRolesContext == "addToRole") {
      var x = {
        candidate_id: this.contexData.openRolesContextId,
        role_details: role_detail,
      };
      this.talentService.addCandidateToRole(x).subscribe((result) => {
        this.ngZone.run(() => {
          this.talentService.getSimilarRoles(role_id).subscribe((similarResult) => {
            this.ngZone.run(() => {
              if (similarResult.length > 0 && !this.showingSimilarRoles) {
                let similarRoleIds = similarResult.map((n) => n.role_id);
                this.roles = this.allRoles.filter((n) =>
                  similarRoleIds.includes(n.role_id)
                );
                let role = this.allRoles.find((n) => n.role_id === role_id);
                this.showingSimilarRoles = role.client + " - " + role.title;
              }
            });
          });
          if (result.status == "success") {
            alert("Add Candidate to the Role: " + role_detail["client"] + " successfully");
          } else {
            alert("Add failed, please connect with support");
          }
        });
      });
    } else if (this.contexData.openRolesContext == "openRoles") {
      this.talentService.addRoleToUser(role_id).subscribe((result) => {
        this.ngZone.run(() => {
          console.log(result);
        });
      });
    }
  }

  detail_toggle(id): void {
    this.show_detail[id] = !this.show_detail[id];
  }

  clickEdit() {
    if (this.showChangeRoleOwner == 1) {
      this.showEdit = false;
      this.showSave = true;
      this.isEditable = false;
    }
  }

  clickEditSourcer() {
    if (this.isEditable) {
      this.showEditSourcer = false;
      this.showSaveSourcer = true;
      this.isEditable = false;
    }
  }

  clickEditRecruiter() {
    if (this.isEditable) {
      this.showEditRecruiter = false;
      this.showSaveRecruiter = true;
      this.isEditable = false;
    }
  }

  clickEditPriority() {
    if (this.isEditable) {
      this.showEditPriority = false;
      this.showSavePriority = true;
      this.isEditable = false;
    }
  }

  clickEditPipeline() {
    if (this.isEditable) {
      this.showEditPipeline = false;
      this.showSavePipeline = true;
      this.isEditable = false;
    }
  }

  clickEditManager() {
    if (this.isEditable) {
      this.showEditManager = false;
      this.showSaveManager = true;
      this.isEditable = false;
    }
  }

  clickEditWorkPermission() {
    if (this.isEditable) {
      this.showEditWorkPermission = false;
      this.showSaveWorkPermission = true;
      this.isEditable = false;
    }
  }

  clickEditPracticeGroup() {
    if (this.isEditable) {
      this.showEditPracticeGroup = false;
      this.showSavePracticeGroup = true;
      this.isEditable = false;
    }
  }

  clickCancelEditPracticeGroup() {
    this.showEditPracticeGroup = true;
    this.showSavePracticeGroup = false;
    this.isEditable = true;
  }

  createRole() {
    const dialogRef: MatDialogRef<RoleDetailEditComponent> = this.dialog.open(RoleDetailEditComponent, {
      width: "1000px",
      height: "500px",
      data: {
        initialDetails: {
          status: 1,
          type: 1,
          category: 1,
          compensation_currency: 1,
          open_compensation: 0,
          sponsorship: 5,
          location_state: 1,
          open_date: formatDate(new Date(), "yyyy-MM-dd", "en"),
          contract_compensation: 0,
          contract_compensation_daily: 0,
          bill_rate: 0,
          bill_rate_daily: 0,
          bill_rate_currency: 1,
          on_hold_notes: "",
          priority: 10,
          sourcers: [],
          recruiters: [],
          work_permission: [],
        },
        create_new: true,
      },
    });
    const sub = dialogRef.componentInstance.doneWithSave.subscribe((save) => {
      dialogRef.close();
      if (save) {
        this.Checkbox();
      }
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log("The dialog was closed");
    });
  }

  cloneRole = (inputRole) => {
    inputRole["title"] = inputRole["title"].split(" - Req. Number")[0];
    const dialogRef: MatDialogRef<RoleDetailEditComponent> = this.dialog.open(RoleDetailEditComponent, {
      width: "1000px",
      height: "500px",
      data: {
        initialDetails: inputRole,
        create_new: true,
      },
    });
    const sub = dialogRef.componentInstance.doneWithSave.subscribe((save) => {
      dialogRef.close();
      if (save) {
        this.Checkbox();
      }
    });
  };

  save() {
    this.showSave = false;
    this.showEdit = true;
    this.talentService.saveRoleOwners(this.saveChangesDict).subscribe(
      () => {},
      (error) => { window.alert("Error saving role owners"); },
      () => {
        this.ngZone.run(() => {
          this.saveChangesDict = [];
          if (this.open_only) { this.getOpenRoles("open"); } else { this.getOpenRoles("all"); }
        });
      }
    );
  }

  saveRecruiter() {
    this.isEditable = true;
    this.showSaveRecruiter = false;
    this.showEditRecruiter = true;
    this.talentService.saveRoleRecruiter(this.saveChangesDictRecruiter).subscribe(
      () => {},
      (error) => { window.alert("Error saving Recruiter"); },
      () => {
        this.ngZone.run(() => {
          this.saveChangesDictRecruiter = {};
          if (this.open_only) { this.getOpenRoles("open"); } else { this.getOpenRoles("all"); }
        });
      }
    );
  }

  saveSourcer() {
    this.isEditable = true;
    this.showSaveSourcer = false;
    this.showEditSourcer = true;
    this.talentService.saveRoleSourcer(this.saveChangesDictSourcer).subscribe(
      () => {},
      (error) => { window.alert("Error saving sourcer"); },
      () => {
        this.ngZone.run(() => {
          this.saveChangesDictSourcer = {};
          if (this.open_only) { this.getOpenRoles("open"); } else { this.getOpenRoles("all"); }
        });
      }
    );
  }

  savePriority() {
    this.showSavePriority = false;
    this.showEditPriority = true;
    this.isEditable = true;
    this.talentService.saveRolePriority(this.saveChangesDictPriority).subscribe(
      () => {},
      (error) => { window.alert("Error saving Priority"); },
      () => {
        this.ngZone.run(() => {
          this.saveChangesDictPriority = [];
          if (this.open_only) { this.getOpenRoles("open"); } else { this.getOpenRoles("all"); }
        });
      }
    );
  }

  savePipeline() {
    this.showSavePipeline = false;
    this.showEditPipeline = true;
    this.isEditable = true;
    this.talentService.saveRolePipeline(this.saveChangesDictPipleine).subscribe(
      () => {},
      (error) => { window.alert("Error saving Pipeline"); },
      () => {
        this.ngZone.run(() => {
          this.saveChangesDictPipleine = [];
          if (this.open_only) { this.getOpenRoles("open"); } else { this.getOpenRoles("all"); }
        });
      }
    );
  }

  saveManager() {
    this.showSaveManager = false;
    this.showEditManager = true;
    this.isEditable = true;
    this.talentService.saveRoleManager(this.saveChangesDictManager).subscribe(
      () => {},
      (error) => { window.alert("Error saving Manager"); },
      () => {
        this.ngZone.run(() => {
          this.saveChangesDictManager = [];
          if (this.open_only) { this.getOpenRoles("open"); } else { this.getOpenRoles("all"); }
        });
      }
    );
  }

  saveWorkPermission() {
    this.isEditable = true;
    this.showSaveWorkPermission = false;
    this.showEditWorkPermission = true;
    this.talentService.saveWorkPermission(this.saveChangesWorkPermission).subscribe(
      () => {},
      (error) => { window.alert("Error saving Work Permission"); },
      () => {
        this.ngZone.run(() => {
          this.saveChangesWorkPermission = {};
          if (this.open_only) { this.getOpenRoles("open"); } else { this.getOpenRoles("all"); }
        });
      }
    );
  }

  savePracticeGroup() {
    this.isEditable = true;
    this.showSavePracticeGroup = false;
    this.showEditPracticeGroup = true;
    this.talentService.saveRolePracticeGroup(this.saveChangesDictPracticeGroup).subscribe(
      () => {},
      (error) => { window.alert("Error saving Practice Group"); },
      () => {
        this.ngZone.run(() => {
          this.saveChangesDictPracticeGroup = {};
          if (this.open_only) { this.getOpenRoles("open"); } else { this.getOpenRoles("all"); }
        });
      }
    );
  }

  backToAllRoles() {
    this.roles = this.allRoles;
    this.showingSimilarRoles = false;
  }

  onChange(newValue, role_id) {
    this.saveChangesDict.push([parseInt(newValue), role_id]);
  }

  onChangeSourcer(newValue, role_id) {
    this.saveChangesDictSourcer[role_id] = newValue;
  }

  onChangePriority(newValue, role_id) {
    this.saveChangesDictPriority.push([newValue, role_id]);
    console.log("Priority", this.saveChangesDictPriority);
  }

  onChangePipeline(newId: number, role_id: number) {
    this.saveChangesDictPipleine.push([Number(newId), role_id]);
    console.log("Pipeline", this.saveChangesDictPipleine);
  }

  onChangeRecruiter(newValue, role_id) {
    this.saveChangesDictRecruiter[role_id] = newValue;
    console.log("Recruiter", this.saveChangesDictRecruiter);
  }

  onChangeManager(newValue, role_id) {
    this.saveChangesDictManager.push([newValue, role_id]);
    console.log("Manager", this.saveChangesDictManager);
  }

  onChangeWorkPermission(newValue, role_id) {
    this.saveChangesWorkPermission[role_id] = newValue;
  }

  onChangePracticeGroup(newValue, role_id) {
    this.saveChangesDictPracticeGroup.push({ role_id: role_id, newGroupId: newValue });
  }

  openClientTab(company_name) {
    let url = this.base_url + "/client/" + this.clients_lookup[company_name];
    window.open(url, "_blank");
  }

  exportexcel(): void {
    let element = document.getElementById("excel-table");
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, this.fileName);
  }

  getPriorityColor(priority: number): string {
    if (priority == 1) { return "#ffffff"; }
    else if (priority >= 2 && priority <= 3) { return '#ffe3e3'; }
    else if (priority >= 4 && priority <= 7) { return '#fbffe1'; }
    else if (priority >= 8 && priority <= 10) { return '#e1ffe6'; }
    return 'transparent';
  }

  getPipelineColour(targetId: any): string {
    const matchingOption = this.pipelineOptions.find(option => option.id == targetId);
    if (matchingOption) { return matchingOption.colour; }
    return "#ffffff";
  }
}